import { Box, Typography, makeStyles } from '@material-ui/core';

import { MessageBaseProps } from 'components/MessageBase';
import dayjs from 'services/dayjs';
import getUsuarioNomeExibicao from 'utils/getUsuarioNomeExibicao';

const useStyles = makeStyles(({ palette, spacing }) => {
  const isDark = palette.type === 'dark';
  const bgColor = isDark ? '#4A452B' : '#FFE8A3';
  const textColor = isDark ? '#FFF8E1' : '#5C4B00';

  return {
    root: {
      display: 'flex',
      justifyContent: 'center',
      paddingBlock: spacing(0.5),
      paddingInline: spacing(1),
    },
    bubble: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: spacing(0.5),
      width: 500,
      maxWidth: '100%',
      padding: spacing(1, 1.5),
      borderRadius: spacing(1),
      backgroundColor: bgColor,
      color: textColor,
      border: `1px solid ${isDark ? '#6B633A' : '#F5CC50'}`,
    },
    header: {
      display: 'flex',
      alignItems: 'center',
      gap: spacing(0.5),
      color: textColor,
    },
    label: {
      fontWeight: 600,
      color: textColor,
    },
    author: {
      fontWeight: 500,
      color: isDark ? 'rgba(255, 248, 225, 0.7)' : 'rgba(92, 75, 0, 0.7)',
    },
    text: {
      color: textColor,
      wordBreak: 'break-word',
      whiteSpace: 'pre-wrap',
      textAlign: 'center',
      width: '100%',
      marginTop: spacing(0.5),
    },
    footer: {
      display: 'flex',
      justifyContent: 'flex-end',
      width: '100%',
      marginTop: spacing(0.5),
    },
    time: {
      color: isDark ? 'rgba(255, 248, 225, 0.5)' : 'rgba(92, 75, 0, 0.5)',
    },
  };
});

export default function CommentMessage({ mensagem }: MessageBaseProps) {
  const classes = useStyles();
  const { mensagem: texto, usuario, criadoEm } = mensagem;
  const autorNome = getUsuarioNomeExibicao(usuario) || 'Atendente';

  return (
    <Box className={classes.root}>
      <Box className={classes.bubble}>
        <Box className={classes.header}>
          <Typography variant="caption" className={classes.label}>
            Atendente {autorNome} comentou:
          </Typography>
        </Box>

        <Typography variant="body2" className={classes.text}>
          {texto}
        </Typography>

        <Box className={classes.footer}>
          <Typography variant="caption" className={classes.time}>
            {dayjs(criadoEm).format('HH:mm')}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
